import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;

export const ModalContent = styled.div`
    background: white;
    padding: 32px;
    box-shadow: 4px 10px 21px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    max-width: 375px;
    width: 90%;
    border-radius: 8px;
`;

export const ModalTitle = styled.h1`
    color: var(--primary-color);
    text-align: left;
    font-family: var(--font-family-base);
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: 0;
    margin: 0 0 16px 0;
`;

export const ModalText = styled.p`
    color: var(--text-color);
    text-align: left;
    font-family: var(--font-family-base);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 0 0 32px 0;
    word-wrap: break-word;
`;

export const ModalButton = styled.button`
    background-color: var(--button-primary-color);
    color: var(--button-primary-text);
    border: none;
    padding: 12px 40px;
    font-family: var(--font-family-base);
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    text-transform: uppercase;
    cursor: pointer;
    min-width: 190px;
    width: 100%;
    margin-top: 0;
    border-radius: 4px;
    
    &:hover,
    &:focus,
    &:active {
        background-color: var(--button-primary-color);
    }

    &:focus-visible {
        outline: 2px solid var(--button-primary-color);
        outline-offset: 2px;
    }
`;
